(() => {
  const initStoreLocatorStickyCta = () => {
    const cta = document.querySelector(
      '[data-store-locator-sticky-cta]'
    );

    if (!cta || cta.dataset.initialized === 'true') return;

    cta.dataset.initialized = 'true';

    const showAfterFold =
      cta.dataset.showAfterFold === 'true';

    let ticking = false;

    const updateVisibility = () => {
      const shouldShow =
        !showAfterFold ||
        window.scrollY >= window.innerHeight;

      cta.classList.toggle('is-visible', shouldShow);
      ticking = false;
    };

    const requestUpdate = () => {
      if (ticking) return;

      ticking = true;
      window.requestAnimationFrame(updateVisibility);
    };

    window.addEventListener(
      'scroll',
      requestUpdate,
      { passive: true }
    );

    window.addEventListener('resize', requestUpdate);

    updateVisibility();
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initStoreLocatorStickyCta,
      { once: true }
    );
  } else {
    initStoreLocatorStickyCta();
  }

  document.addEventListener(
    'shopify:section:load',
    initStoreLocatorStickyCta
  );
})();
